function drawAxes(ctx) {
  ctx.strokeStyle = 'rgb(192,0,0)';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(1, 0);
  ctx.stroke();
  ctx.strokeStyle = 'rgb(0,192,0)';
  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(0, 1);
  ctx.stroke();
}

function setColorFromDebugDrawCallback(Box2D, context, color) {            
  return;
  var col = Box2D.wrapPointer(color, Box2D.b2Color);
  var red = (col.get_r() * 255)|0;
  var green = (col.get_g() * 255)|0;
  var blue = (col.get_b() * 255)|0;
  var colStr = red+","+green+","+blue;
  context.fillStyle = "rgba("+colStr+",0.5)";
  context.strokeStyle = "rgb("+colStr+")";
}

function drawSegment(Box2D, gameobjects, vert1, vert2) {
  const graphics = gameobjects.graphics;
  const coords = gameobjects.coords;

  var vert1V = Box2D.wrapPointer(vert1, Box2D.b2Vec2);
  var vert2V = Box2D.wrapPointer(vert2, Box2D.b2Vec2);                    
  const x1 = vert1V.get_x();
  const y1 = vert1V.get_y();
  const x2 = vert2V.get_x();
  const y2 = vert2V.get_y();

  graphics.lineStyle(0.1, 0xff00ff);
  graphics.moveTo(x1,y1);
  graphics.lineTo(x2,y2);
}

function drawPolygon(Box2D, gameobjects, vertices, vertexCount, fill) {
  const graphics = gameobjects.graphics;
  const coords = gameobjects.coords;
  //context.beginPath();
  graphics.beginFill(0x0000ff);
  graphics.lineStyle(0.1, 0xffff00);
  for(var tmpI=0;tmpI<vertexCount;tmpI++) {
    var vert = Box2D.wrapPointer(vertices+(tmpI*8), Box2D.b2Vec2);
    const x = vert.get_x();
    const y = vert.get_y();
    if ( tmpI == 0 )
      graphics.moveTo(x, y);
    else
      graphics.lineTo(x, y);
  }
  graphics.endFill()
  //context.closePath();
  //if (fill)
    //context.fill();
  //context.stroke();
}

function drawCircle(Box2D, gameobjects, center, radius, axis, fill) {                    
  const graphics = gameobjects.graphics;
  const coords = gameobjects.coords;
  var centerV = Box2D.wrapPointer(center, Box2D.b2Vec2);
  const x = centerV.get_x();
  const y = centerV.get_y();
  var axisV = Box2D.wrapPointer(axis, Box2D.b2Vec2);


  graphics.lineStyle(0.1, 0x00ff00);
  graphics.beginFill(0x0000ff);
  graphics.drawCircle(x, y, radius);
  graphics.endFill();

  /*
  if (fill) {
    //render axis marker
    var vert2V = copyVec2(centerV);
    vert2V.op_add( scaledVec2(axisV, radius) );
    context.beginPath();
    context.moveTo(centerV.get_x(),centerV.get_y());
    context.lineTo(vert2V.get_x(),vert2V.get_y());
    context.stroke();
  }
  */
}

function drawTransform(Box2D, gameobjects, transform) {
  const graphics = gameobjects.graphics;
  const coords = gameobjects.coords;

  var trans = Box2D.wrapPointer(transform,Box2D.b2Transform);
  var pos = trans.get_p();
  var rot = trans.get_q();
  const x = pos.get_x();
  const y = pos.get_y();
  const angle = rot.GetAngle();

  graphics.lineStyle(0.1, 0xff0000);
  graphics.moveTo(x - Math.cos(angle), y - Math.sin(angle));
  graphics.lineTo(x + Math.cos(angle), y + Math.cos(angle));
  graphics.moveTo(x + Math.cos(angle), y - Math.cos(angle));
  graphics.lineTo(x - Math.cos(angle), y + Math.cos(angle));

  /*
  context.save();
  context.translate(pos.get_x(), pos.get_y());
  context.scale(0.5,0.5);
  context.rotate(rot.GetAngle());
  context.lineWidth *= 2;
  drawAxes(context);
  context.restore();
  */
}

function getCanvasDebugDraw(Box2D, gameobjects) {
  var debugDraw = new Box2D.JSDraw();

  debugDraw.DrawSegment = function(vert1, vert2, color) {
    setColorFromDebugDrawCallback(Box2D, gameobjects, color);
    drawSegment(Box2D, gameobjects, vert1, vert2);
  };

  debugDraw.DrawPolygon = function(vertices, vertexCount, color) {
    setColorFromDebugDrawCallback(Box2D, gameobjects, color);
    drawPolygon(Box2D, gameobjects, vertices, vertexCount, false);
  };

  debugDraw.DrawSolidPolygon = function(vertices, vertexCount, color) {
    setColorFromDebugDrawCallback(Box2D, gameobjects, color);
    drawPolygon(Box2D, gameobjects, vertices, vertexCount, true);
  };

  debugDraw.DrawCircle = function(center, radius, color) {
    setColorFromDebugDrawCallback(Box2D, gameobjects, color);
    var dummyAxis = Box2D.b2Vec2(0,0);
    drawCircle(Box2D, gameobjects, center, radius, dummyAxis, false);
  };

  debugDraw.DrawSolidCircle = function(center, radius, axis, color) {
    setColorFromDebugDrawCallback(Box2D, gameobjects, color);
    drawCircle(Box2D, gameobjects, center, radius, axis, true);
  };

  debugDraw.DrawTransform = function(transform) {
    drawTransform(Box2D, gameobjects, transform);
  };

  return debugDraw;
}
export default {
  getCanvasDebugDraw:getCanvasDebugDraw
}
